module.exports = __webpack_public_path__ + "img/sec-2-click-dis.04692fb7.png";